var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRefreshResults = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 400 600",
  "aria-hidden": "true"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "refresh-results_svg__a",
  d: "M0 0h400v600H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "refresh-results_svg__c",
  d: "M0 .394h49.701v66.43H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "refresh-results_svg__e",
  d: "M0 238.884h319.96V.434H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.872.434L.17.78V79.73h42.122c-.738 5.397-.5 9.737-.5 9.737 24.281 5.217 97.12 1.74 97.12 1.74V.478l-1.04.002",
  id: "refresh-results_svg__g"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "refresh-results_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#refresh-results_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#refresh-results_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M134.975 511.828c0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16 8.836 0 16 7.163 16 16",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.043 525.695c0 8.837-7.164 16-16 16s-16-7.163-16-16c0-8.836 7.164-16 16-16s16 7.164 16 16",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.886 537.066c0 8.56-8.283 15.5-18.5 15.5s-18.5-6.94-18.5-15.5c0-8.56 8.283-15.5 18.5-15.5s18.5 6.94 18.5 15.5M169.1 530.13c0 7.455-6.044 13.5-13.5 13.5s-13.5-6.045-13.5-13.5c0-7.456 6.044-13.5 13.5-13.5s13.5 6.044 13.5 13.5",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.25 518.251c0 7.732-6.268 14-14 14s-14-6.268-14-14c0-7.731 6.268-14 14-14s14 6.269 14 14",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.487 535.107c0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14 14 6.268 14 14",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.197 523.428a13.6 13.6 0 01.15 1.898c0 7.463-6.062 13.511-13.537 13.511-1.512 0-2.96-.258-4.319-.714-2.503 3.38-6.512 5.58-11.045 5.58-2.112 0-4.103-.49-5.89-1.338-3.354 3.476-8.426 5.692-14.101 5.692-8.388 0-15.451-4.84-17.607-11.436a15.922 15.922 0 01-15.554-8.234c1.298 7.474 7.81 13.162 15.67 13.162.525 0 1.045-.028 1.558-.078 2.155 6.596 9.217 11.435 17.605 11.435 5.676 0 10.746-2.215 14.101-5.69a13.687 13.687 0 005.89 1.338c4.534 0 8.543-2.201 11.047-5.58 1.356.455 2.805.714 4.318.714 7.475 0 13.536-6.05 13.536-13.511 0-2.46-.67-4.762-1.822-6.75",
  fill: "#EBEBEB"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#refresh-results_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M292.427 61.497c0 15.463-12.537 28-28 28-15.464 0-28-12.537-28-28 0-15.464 12.536-28 28-28 15.463 0 28 12.536 28 28",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.416 84.907c0 15.187-12.313 27.5-27.5 27.5-15.188 0-27.5-12.313-27.5-27.5 0-15.188 12.312-27.5 27.5-27.5 15.187 0 27.5 12.312 27.5 27.5",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.544 104.873c0 14.911-14.104 27-31.5 27s-31.5-12.089-31.5-27 14.104-27 31.5-27 31.5 12.089 31.5 27M351.091 92.862c0 12.978-10.522 23.5-23.5 23.5s-23.5-10.522-23.5-23.5 10.522-23.5 23.5-23.5 23.5 10.522 23.5 23.5",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M324.68 72.02c0 13.255-10.745 24-24 24-13.254 0-24-10.745-24-24 0-13.254 10.746-24 24-24 13.255 0 24 10.746 24 24",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.09 101.082c0 13.255-10.746 24-24 24-13.255 0-24-10.745-24-24 0-13.254 10.745-24 24-24 13.254 0 24 10.746 24 24",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.206 81.083c.151 1.078.26 2.171.26 3.291 0 12.934-10.536 23.419-23.528 23.419-2.628 0-5.147-.448-7.507-1.239-4.35 5.858-11.319 9.673-19.198 9.673-3.67 0-7.13-.848-10.237-2.32-5.83 6.025-14.645 9.866-24.51 9.866-14.578 0-26.855-8.389-30.601-19.822a27.685 27.685 0 01-27.034-14.273c2.254 12.955 13.575 22.816 27.234 22.816.914 0 1.816-.05 2.708-.136 3.746 11.434 16.021 19.821 30.6 19.821 9.865 0 18.678-3.84 24.51-9.864a23.843 23.843 0 0010.237 2.32c7.88 0 14.847-3.815 19.2-9.673a23.548 23.548 0 007.505 1.238c12.993 0 23.527-10.484 23.527-23.419 0-4.265-1.164-8.253-3.166-11.698",
  fill: "#EBEBEB"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#refresh-results_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(40 180)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 51.024)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "refresh-results_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#refresh-results_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M49.701 32.903S39.786.393 18.541.393C-2.708.394.124 34.788.124 34.788S-.167 66.824 38.46 66.824L49.7 32.903z",
  fill: "#0068B3",
  mask: "url(#refresh-results_svg__d)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M296.324 106.615a122.641 122.641 0 00-4.833-2c-9.146-17.497-53.407-20.363-106.631-20.363H22.236v12.076s22.671 79.959 176.088 81.19c1.055.011 2.114.016 3.175.016 38.281 0 72.44-6.282 94.825-16.11v-54.809z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.979 133.271c24.062 21.135 68.58 43.6 149.346 44.247 1.054.01 2.112.015 3.173.015 38.282 0 72.442-6.281 94.826-16.11v-28.152H48.979z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.324 146.883c-35.739 8.717-131.411 27.303-222.304 3.758 26.466 14.532 65.905 26.409 124.304 26.877 1.055.01 2.114.015 3.175.015 38.281 0 72.44-6.28 94.825-16.108v-14.542z",
  fill: "#D8D8D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.204 62.108v21.219h-84.462V59.47c-39.678 9.054-47.966 30.794-47.966 30.794s78.553 13.18 163.362 0c0 0-2.185-18.108-30.934-28.156",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.96 133.984c0 4.98-4.046 9.017-9.037 9.017-4.991 0-9.038-4.037-9.038-9.017 0-4.98 4.047-9.017 9.038-9.017 4.991 0 9.037 4.036 9.037 9.017",
  fill: "#D8D8D8"
}), /*#__PURE__*/React.createElement("mask", {
  id: "refresh-results_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#refresh-results_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F7",
  mask: "url(#refresh-results_svg__f)",
  d: "M266.23 104.659h1.67v-9.996h-1.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0068B3",
  mask: "url(#refresh-results_svg__f)",
  d: "M217.381 159.752l-54.11 27.522-62.083-.486 39.094-27.036z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005693",
  mask: "url(#refresh-results_svg__f)",
  d: "M217.381 159.752v4.156l-54.249 23.427-3.304-.728z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.523 186.9c0 1.633-13.966 2.956-31.192 2.956-17.227 0-31.192-1.323-31.192-2.956s13.965-2.956 31.192-2.956c17.226 0 31.192 1.323 31.192 2.956",
  fill: "#005693",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.763 104.261v59.446c11.927-1.214 21.314-11.34 21.314-23.548v-12.35c0-12.208-9.387-22.335-21.314-23.548",
  fill: "#0068B3",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.831 97.912c0-13.791-1.089-24.972-2.433-24.972-1.344 0-2.433 11.18-2.433 24.972 0 13.793 1.09 24.973 2.433 24.973 1.344 0 2.433-11.18 2.433-24.973M316.831 170.055c0-13.792-1.089-24.973-2.433-24.973-1.344 0-2.433 11.181-2.433 24.973s1.09 24.972 2.433 24.972c1.344 0 2.433-11.18 2.433-24.972",
  fill: "#D8D8D8",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.763 133.271v30.436c11.927-1.214 21.314-11.34 21.314-23.548v-6.888h-21.314z",
  fill: "#005693",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.79 177.32a2.089 2.089 0 01-2.085-2.08v-45.09c0-1.145.938-2.08 2.085-2.08a2.09 2.09 0 012.086 2.08v45.09a2.09 2.09 0 01-2.086 2.08M159.377 177.32a2.089 2.089 0 01-2.085-2.08v-45.09c0-1.145.938-2.08 2.085-2.08s2.085.935 2.085 2.08v45.09c0 1.143-.938 2.08-2.085 2.08",
  fill: "#5C9ECE",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0068B3",
  mask: "url(#refresh-results_svg__f)",
  d: "M217.381 113.276l-54.11 27.521-62.083-.486 39.094-27.035z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005693",
  mask: "url(#refresh-results_svg__f)",
  d: "M217.381 113.276v4.157l-54.249 23.427-3.304-.73z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.523 140.424c0 1.632-13.966 2.955-31.192 2.955-17.227 0-31.192-1.323-31.192-2.955 0-1.633 13.965-2.956 31.192-2.956 17.226 0 31.192 1.323 31.192 2.956M123.229 89.223s-1.39-24.625 12.512-29.481v23.586h84.81v7.63s-72.991 3.468-97.322-1.735",
  fill: "#005693",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.984 65.292v28.614s15.468.346 26.416-5.55c0 0-8.689-17.514-26.416-23.064M126.01 64.598s-6.78 11.792-5.736 26.88c0 0-15.988-.348-25.547-6.937 0 0 10.949-14.047 31.282-19.943",
  fill: "#0068B3",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.055 91.825s38.408 6.416 97.844 2.08c0 0-57.003 9.885-97.844-2.08",
  fill: "#D8D8D8",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.187 96.28H24.082S6.18 100.93 6.875 108.56c.695 7.63 25.939 9.625 52.312-12.28",
  fill: "#005693",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.144 96.28H23.039S5.659 99.54 6.354 107.172c.695 7.63 28.502 7.976 51.79-10.894",
  fill: "#5C9ECE",
  mask: "url(#refresh-results_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.551 90.958v-7.63h-84.81s-12.638 4.652-12.513 5.895c24.33 5.203 97.323 1.735 97.323 1.735",
  fill: "#0C4466",
  mask: "url(#refresh-results_svg__f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(121.86 180)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "refresh-results_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#refresh-results_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M89.378 53.934s-1.851-7.567-14.95-8.851C61.33 43.798 55.634 62.214 35.702 62.785c-19.932.57-24.63-18.273-24.63-18.273s-8.26 12.705-6.978 21.557c1.282 8.85 24.49 18.7 41.86 6.852 17.369-11.849 23.634-26.695 43.281-14.205 0 0 4.13-.214.143-4.782",
  fill: "#F2C55C",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.943 55.79S86.72 48.7 73.337 48.27c0 0 6.96 1.805 16.341 10.23 9.381 8.424 1.265-2.711 1.265-2.711M106.534 52.791l-1.531-1.748-1.994 2.747s2.955 1.642 3.062 1.571c.107-.07.463-2.57.463-2.57",
  fill: "#ECA400",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.689 27.046l-1.898 1.285L125.747 25s1.329-.857 2.942 2.046",
  fill: "#684635",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.073 62.245l-7.053 5.8-3 48.765s23.22 7.792 38.63-.235l-2.847-28.933-3.417-20.746-4.746-4.76-17.567.109z",
  fill: "#8E6042",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E6042",
  mask: "url(#refresh-results_svg__h)",
  d: "M75.836 71.654l-3.797 35.214 1.252 34.657 4.254.174 2.262-33.457 4.43-42.727z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.203 40.377s.826 13.087-4.13 21.868c0 0 11.493 7.315 19.086 1.795 0 0-2.956-9.812-1.14-20.747l-13.816-2.916z",
  fill: "#C69879",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.21 61.185l.176-.474c-.603-3.149-1.263-8.227-.797-13.903l-13.335-4.037c-.001.391-.008.821-.02 1.287l13.976 17.127z",
  fill: "#A36F58",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.738 9.894s13.493 3.037 14.154 20.597l-2.643 3.756s-.606-11.763-11.51-24.353",
  fill: "#C69879",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.424 35.02v10.603l26.816 12.17s7.11-9.74 6.009-32.492c-1.102-22.752-30.457-19.549-35.524-7.62-5.067 11.927 2.699 17.339 2.699 17.339",
  fill: "#C69879",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C69879",
  mask: "url(#refresh-results_svg__h)",
  d: "M124.753 32.59l3.14 10.602-4.296 2.983-4.792-2.816z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B78869",
  mask: "url(#refresh-results_svg__h)",
  d: "M127.892 43.193h-7.27l.166-2.65-1.983 2.816 4.792 2.816zM122.165 30.823l1.035 3.333s-3.322 4.283-9.397 1.333l2.373-.666s-6.265-.476-9.302-7.042l5.79-1.523 9.5 4.565z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#202020",
  mask: "url(#refresh-results_svg__h)",
  d: "M106.495 27.59l6.264-.667 9.405 3.9 1.415-2.091-11.01-3.807z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.491 49.194s-5.41-1.428-10.536-6.186l1.709-1.048-3.228.477.192 3.33.615-1.76s4.035 4.378 11.248 5.187",
  fill: "#996A55",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.457 85.754l3.203-23.84 3.916 3.663 8.732 61.1s-3.986 2.094-8.352 2.284l-3.417-7.614-4.082-35.593z",
  fill: "#8E6042",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.793 61.128l14.664 24.626 5.6 35.022-2.658 9.136s-17.275 2.476-29.233-3.425l3.559-58.53 8.068-6.829z",
  fill: "#8E6042",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.962 67.814l-6.265 4.045-4.176 34.642.38 31.977s3.227 4.569 9.302 2.474l1.138-36.354-.379-36.784z",
  fill: "#8E6042",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#684635",
  mask: "url(#refresh-results_svg__h)",
  d: "M81.531 86.705l1.71 17.892-2.089 22.651zM103.457 85.754l4.652 36.354s-.38-23.602-4.652-36.354M80.725 67.957s10.377 13.194 22.906 16.715c0 0 7.404-5.329 7.024-18.463l-7.119 17.13-22.811-15.382z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.678 58.5s-6.707 2.45-8.716 9.314l22.669 16.858-2.752-18.749-11.2-7.423z",
  fill: "#9E6E54",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.63 84.672s7.437-12.208 6.946-19.094l-4.287-5.745-.19 4.187-5.221 1.903s3.417 7.614 2.753 18.75",
  fill: "#9E6E54",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.619 30.664l.356-4.782s5.836-7.351 20.857 1.357c0 0 2.278 1.07 3.916.428 0 0 3.536 5.305-1.163 11.159l-1.472-4.902s-.64-.69-1.992-.119c0 0-1.994 5.283-11.248 3.212-9.254-2.07-9.254-6.353-9.254-6.353",
  fill: "#684635",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.608 31.093v-4.426s3.275-2.355 9.255-1.285c5.979 1.071 7.474 4.069 7.474 4.069l-.498 3.926s-7.902 4.925-16.23-2.284",
  fill: "#5C9ECE",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.541 33.448l.783-3.284 1.352-.285s1.923 3.212-.996 6.853l-1.139-3.284z",
  fill: "#B9D5EA",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#684635",
  mask: "url(#refresh-results_svg__h)",
  d: "M102.975 25.882l-3.702.57-1.21 4.283 4.912.143z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.679 34.997l6.697-6.715c-1.018-.963-2.978-2.267-6.513-2.9-.787-.141-1.524-.22-2.215-.255l-6.44 6.458c3.025 2.419 5.968 3.282 8.47 3.412",
  fill: "#B9D5EA",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.676 29.88l-1.352.285-.783 3.283.186.536 2.486-2.494c-.169-.996-.537-1.61-.537-1.61",
  fill: "#5C9ECE",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.584 48.58s6.905 5.996 14.95 4.212l.996 1.856-1.43 9.372-5.404 2.12-11.461-7.424-.213-8.423 2.562-1.713z",
  fill: "#F2C55C",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.875 68.828c-21.071 6.09-34.55-14.276-34.55-14.276a9.361 9.361 0 00-.114-.447c-1.18 3.015-2.139 6.363-2.24 9.458 17.539 17.616 36.904 5.265 36.904 5.265M92.622 54.875s8.717 6.691 14.417 2.833l-.452 2.977s-7.837 2.62-13.965-5.81",
  fill: "#ECA400",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.689 27.046s-7.973-4.568-21.925-4.996c0 0-7.405-.285-8.258 9.136-.855 9.422-.57 25.458-3.133 26.743-2.563 1.285-11.39 1.808-11.39-26.743 0-21.288 11.58-25.506 21.547-25.79 9.966-.287 23.444 6.375 23.159 21.65",
  fill: "#8E6042",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.689 27.046s.95-.714 1.044-1.666c.095-.951-1.14-2.284-1.14-2.284s-11.484-4.853-21.64-4.473c-10.156.382-11.294 9.327-11.294 10.85 0 1.522-.855 24.173-1.52 25.315-.664 1.142-6.407.237-8.684-7.804-1.075-3.798.237 2.855.237 2.855s1.899 8.852 8.352 8.376c0 0 3.607 1.522 3.607-10.755 0-6.293.855-16.274.855-16.274s.474-8.47 8.258-8.756c7.783-.285 21.925 4.616 21.925 4.616",
  fill: "#684635",
  mask: "url(#refresh-results_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.248 13.58s7.308-7.995 17.75-7.233c10.44.762 17.37 10.469 17.37 10.469S109.8 2.445 90.248 13.58",
  fill: "#9E6E54",
  mask: "url(#refresh-results_svg__h)"
}))))));
export default SvgRefreshResults;